const Footer = () => {
    return (
        <footer>
            <p>&copy; 2026 Avinash Kumar Sharma. All rights reserved.</p>
        </footer>
    )
}

export default Footer;